import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import App from './App';
import Lobby from './pages/Lobby';
import Room from './pages/Room';
import Impressum from './pages/Impressum';

const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            { index: true, element: <Lobby /> },
            { path: '/r/:roomId', element: <Room /> },
            { path: '/impressum', element: <Impressum /> }
        ]
    }
]);

createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);
